import getCharts from '../getCharts'
import { AppointmentData } from '../../constants/api.config'

export default async function PatientAppointmentDetails(Mode, ID = '-1', ScheduleDate = '', ProviderID = '', AppointmentDetails = '', CreatedDate = '') {
  try {
    const payload = { Mode, ID, ScheduleDate, ProviderID, AppointmentDetails, CreatedDate }
    const res = await getCharts(AppointmentData, payload)
    return res.data
  } catch (error) {
    return error
  }
}
